import { Navigate, useParams, useSearchParams } from 'react-router-dom';

import store from '../redux/store';

import Clients from './adminSystem/ClientsComponent';
import ClientNew from "./adminSystem/ClientNewComponent";
import ClientManagement from './adminSystem/ClientManagementComponent';
import ClientSubconNew from "./adminSystem/ClientSubconNewComponent";
import ClientSubconManagement from './adminSystem/ClientSubconManagementComponent';
import MyClientManagement from './adminSystem/MyClientComponent';

import { RefreshClientsCachedData, RefreshClientSubcontractantiCachedData, RefreshClientSubcontractedCachedData } from './AFStoreDataRefresh';
import { RefreshEmployersByCIDCachedData, RefreshWorksiteByCIDCachedData } from './AFStoreDataRefresh';
import { DispatchAF } from './AFStoreDispatchAction';

export const ClientsPage = () => {
    const reduxStore = store.getState();

    return (
        <Clients
            loadComponentData={ClientsDataLoader}
            clients={reduxStore.clients}
        />
    );
}

const ClientsDataLoader = () => {
    RefreshClientsCachedData();
}


export const ClientNewPage = () => {
    const reduxStore = store.getState();

    return (
        <ClientNew
            postClient={DispatchAF.postClient}
            mostRecentClientId={reduxStore.bucket.bucket.mostRecentClientId}
            dataStatus={reduxStore.clients.status}
        />
    );
}


export const ClientManagementPage = () => {
    const reduxStore = store.getState();

    const { clientId } = useParams();
    const cId = parseInt(clientId, 10)

    return (
        <ClientManagement
            loadComponentData={ManagedClientDataLoader}
            client={reduxStore.clients.clients.find((client) => client.id === cId)}
            allClients={reduxStore.clients.clients}
            clientSubcontractanti={reduxStore.clientSubcontractors.clientSubcontractors}
            clientSubcontracted={reduxStore.clientSubcontracted.clientSubcontracted}
            dataStatus={reduxStore.clients.status}
            patchClient={DispatchAF.patchClient}
        />
    );
};


export const MyClientPage =() => {
    const reduxStore = store.getState();

    const myClientId = reduxStore.auth.afUser.generalSection.clientId;

    return (
        <MyClientManagement
            loadComponentData={ManagedClientDataLoader}
            myClientId={myClientId}
            client={reduxStore.clients.clients.find((client) => client.id === myClientId)}
            allClients={reduxStore.clients.clients}
            clientSubcontractanti={reduxStore.clientSubcontractors.clientSubcontractors}
            clientSubcontracted={reduxStore.clientSubcontracted.clientSubcontracted}
            dataStatus={reduxStore.clients.status}
            patchClient={DispatchAF.patchClient}
        />
    );
}


const ManagedClientDataLoader = (clientId) => {
    RefreshClientsCachedData();
    RefreshClientSubcontractantiCachedData(clientId);
    RefreshClientSubcontractedCachedData(clientId);
}


export const ClientSubcontractorNewPage = () => {
    const reduxStore = store.getState();

    let [searchParams, setSearchParams] = useSearchParams();
    const clientIdStr = searchParams.get("clientId");
    const clientId = clientIdStr ? parseInt(clientIdStr, 10) : null;

    const subconIdArray = reduxStore.clientSubcontractors.clientSubcontractors.map((subcon) => subcon.generalSection.clientId)

    return (
        <ClientSubconNew
            loadComponentData={ClientSubconDataLoader}
            postSubcontractor={DispatchAF.postClientSubcon}
            client={reduxStore.clients.clients.find((client) => client.id === clientId)}
            clients={reduxStore.clients.clients
                        .filter( (client) => (client.id != clientId && subconIdArray.indexOf(client.id) < 0))
            }
            employers={reduxStore.employers.employers}
            worksites={reduxStore.worksites.worksites}
        />
    );
}        

export const ClientSubcontractorManagementPage = () => {
    const reduxStore = store.getState();

    const { subconId } = useParams();
    const scId = parseInt(subconId, 10);

    let [searchParams, setSearchParams] = useSearchParams();
    const clientIdStr = searchParams.get("clientId");
    const clientId = clientIdStr ? parseInt(clientIdStr, 10) : null;

    return (
        <ClientSubconManagement
            loadComponentData={ClientSubconDataLoader}
            dataStatus={reduxStore.clientSubcontractors.status}
            patchSubcontractor={DispatchAF.patchClientSubcon}
            subcontractor={reduxStore.clientSubcontractors.clientSubcontractors.find((subcon) => subcon.id === scId)}
            client={reduxStore.clients.clients.find((client) => client.id === clientId)}
            clients={reduxStore.clients.clients.filter( (client) => client.id != clientId)}
            employers={reduxStore.employers.employers}
            worksites={reduxStore.worksites.worksites}
        />
    );
};

const ClientSubconDataLoader = (clientId) => {
    RefreshClientsCachedData();

    RefreshEmployersByCIDCachedData(clientId);
    RefreshWorksiteByCIDCachedData(clientId);
}
